export const ENVIRONMENT = 'TESTING';
// export const ENVIRONMENT = 'PRODUCTION';
